import store from "@frameworks/web/redux/store/index";
import { GETRMDETAILS, GETRMDETAILS_ERROR, GETRMDETAILS_HIDE_ERROR, GETRMDETAILS_START_LOADER, GETRMDETAILS_STOP_LOADER } from "../interface/IGetRmDetails";
class GetRmDetailsGroupsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getRmDetailsData(data) {
        this.dispatch({
            type: GETRMDETAILS,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: GETRMDETAILS_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: GETRMDETAILS_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: GETRMDETAILS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: GETRMDETAILS_STOP_LOADER,
        });
    }
}
export default GetRmDetailsGroupsActions;
